import { createPointsExchangeDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const usePointsExchangeInfoQuery = createPointsExchangeDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
